export const getTeams = async (api) => {
  return api.get("/api/v1/team", {
    params: { filterTeamMemberTypes: ["SPORTSMAN", "VIEWER"] },
  });
};

export const updateTeam = async (api, teamId, payload) => {
  return api.upload(`/api/v1/team/${teamId}`, payload);
};

export const updateTeamMember = async (api, teamMemberId, payload) => {
  return api.put(`/api/v1/team-member/${teamMemberId}`, payload);
};

export const removeTeamMember = async (api, teamMemberId) => {
  return api.delete(`/api/v1/team-member/${teamMemberId}`);
};

export const getTeamSessions = async (api, teamPublicId) => {
  return api.get("/api/v1/team-session", {
    params: { page: 0, size: 1000, teamPublicId },
  });
};

export const getTeamSessionDetails = async (api, sessionId) => {
  return api.get(`/api/v1/team-session/${sessionId}/details`);
};

export const updateTeamSessionTitle = async (api, sessionId, title) => {
  return api.put(`/api/v1/team-session/${sessionId}`, { title });
};

export const getHiddenTeamSessions = async (api, teamPublicId) => {
  return api.get("/api/v1/team-session", {
    params: { page: 0, size: 1000, teamPublicId, isHidden: true },
  });
};

export const setTeamSessionHiddenStatus = async (api, sessionIds, isHidden) => {
  return api.put("/api/v1/team-session/hidden-status", {
    sessionIds,
    isHidden,
  });
};
